import { render, staticRenderFns } from "./UserForbidRecharge.vue?vue&type=template&id=e4727890&scoped=true&"
import script from "./UserForbidRecharge.vue?vue&type=script&lang=js&"
export * from "./UserForbidRecharge.vue?vue&type=script&lang=js&"
import style0 from "./UserForbidRecharge.vue?vue&type=style&index=0&id=e4727890&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4727890",
  null
  
)

export default component.exports